module.exports = __webpack_public_path__ + "static/media/CC20-AP130-12-FAICO.8878bfa6.pdf";